<template>
  <header class="header">
    <div class="base-container-first header__container">
      <BaseLink
        class="header__logo-wrapper"
        :href="`/${locale}`"
      >
        <img
          alt=""
          class="header__logo"
          src="/logos/logo.svg"
        />
        MyDonut
      </BaseLink>

      <TheHeaderSiteLanguageSwitcher />
    </div>
  </header>
</template>

<script lang="ts" setup>
const { locale } = useI18n();
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: var(--z-index-header);
  display: flex;
  background-color: var(--white);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 8%);
}

.header__container {
  max-width: 1286px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  min-width: auto;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
}

.header__logo-wrapper {
  font-family:
    Plus Jakarta Sans,
    Inter,
    system-ui,
    -apple-system,
    sans-serif;
  font-size: 16px;
  font-weight: 700;
  gap: 8px;
}

.header__logo {
  justify-content: center;
  height: 25px;
  width: 25px;
}

@media (--desktop) {
  .header__logo-wrapper {
    font-size: 20px;
    font-weight: 700;
    gap: 12px;
  }

  .header__logo {
    height: 40px;
    width: 40px;
  }
}
</style>
